import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import RateReviewIcon from '@mui/icons-material/RateReview';
import ScienceIcon from '@mui/icons-material/Science';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import MapIcon from '@mui/icons-material/Map';
import ReceiptIcon from '@mui/icons-material/Receipt';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

import { Page } from '../components';
import { ResultsTable } from '../components/ResultsTable';

export const Results = () => <Page maxWidth="xl" render={() => <Content />} />;

const resultContainers = [
  {
    label: 'Batch Rate',
    container: 'ratequality-shipments-batch-results',
    icon: <RateReviewIcon sx={{ fontSize: 40 }} />,
    color: '#1976d2',
  },
  {
    label: 'AP Testing',
    container: 'ratequality-shipments-ap-testing-results',
    icon: <ScienceIcon sx={{ fontSize: 40 }} />,
    color: '#d32f2f',
  },
  {
    label: 'Rate Compare',
    container: 'ratequality-shipments-carrier-rate-compare-results',
    icon: <CompareArrowsIcon sx={{ fontSize: 40 }} />,
    color: '#0288d1',
  },
  {
    label: 'Parcel Rate',
    container: 'ratequality-shipments-parcel-rate-results',
    icon: <LocalShippingIcon sx={{ fontSize: 40 }} />,
    color: '#5e35b1',
  },
  {
    label: 'GEO Mileage',
    container: 'ratequality-shipments-geo-mileage-results',
    icon: <MapIcon sx={{ fontSize: 40 }} />,
    color: '#388e3c',
  },
  {
    label: 'Invoice Audit Analysis',
    container: 'auditanalyses-shipments-results',
    icon: <ReceiptIcon sx={{ fontSize: 40 }} />,
    color: '#e91e63',
  },
  {
    label: 'Custom Analysis',
    container: 'ratequality-shipments-rating-analysis-results',
    icon: <CloudUploadIcon sx={{ fontSize: 40 }} />,
    color: '#f57c00',
  },
  {
    label: 'Shipment Retrieval',
    container: 'ratequality-shipments-retrieval-results',
    icon: <CloudDownloadIcon sx={{ fontSize: 40 }} />,
    color: '#7b1fa2',
  },
];

const Content = () => {
  const [selectedContainer, setSelectedContainer] = React.useState('');

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 1, fontWeight: 600 }}>
        Mass Rating & Analysis Results
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        Select a request type to view and download result files
      </Typography>

      <Grid container spacing={2} sx={{ mb: 4 }}>
        {resultContainers.map((item) => {
          const isSelected = selectedContainer === item.container;
          return (
            <Grid item xs={12} sm={6} md={4} lg={3} key={item.container}>
              <Card
                sx={{
                  height: '100%',
                  minHeight: 120,
                  transition: 'all 0.2s',
                  border: (theme) =>
                    isSelected
                      ? `2px solid ${item.color}`
                      : `1px solid ${theme.palette.divider}`,
                  boxShadow: isSelected
                    ? `0 4px 12px ${item.color}40`
                    : '0 1px 3px rgba(0,0,0,0.05)',
                  backgroundColor: isSelected
                    ? `${item.color}08`
                    : 'background.paper',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: `0 4px 12px ${item.color}30`,
                  },
                }}
              >
                <CardActionArea
                  onClick={() => setSelectedContainer(item.container)}
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 2,
                  }}
                >
                  <CardContent
                    sx={{
                      width: '100%',
                      textAlign: 'center',
                      p: 2,
                      '&:last-child': { pb: 2 },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        mb: 1.5,
                        color: isSelected ? item.color : 'text.secondary',
                      }}
                    >
                      {item.icon}
                    </Box>
                    <Typography
                      variant="subtitle1"
                      component="h3"
                      sx={{
                        fontWeight: isSelected ? 600 : 500,
                        fontSize: '0.95rem',
                        color: isSelected ? item.color : 'text.primary',
                      }}
                    >
                      {item.label}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      {selectedContainer && (
        <ResultsTable key={selectedContainer} containerName={selectedContainer} />
      )}
    </Box>
  );
};
